






















import { Component, Vue, Watch } from "vue-property-decorator";
import { getAppIdFromUA } from "@/common/utils";
import { recordShare } from "./api/dataCollect";
@Component
export default class App extends Vue {
  get keepAlive() {
    return this.$route.meta?.keepAlive;
  }
  flag = false;
  @Watch("$route")
  handler() {
    this.$store.commit("SET_STATE", {
      infoClassifyId: this.$route.query.id as string
    });
    this.flag = true;
  }
  mounted() {
    recordShare();
    if (getAppIdFromUA()) {
      this.$store.commit("SET_STATE", {
        appIdFromUA: getAppIdFromUA()
      });
    }
  }
}
